import * as MyTask from '../services/myTask';

export default {
  namespace: 'myTask',
  state: {},
  effects: {
    *getTaskList({ payload: { values } }, { call, put }) {
      const response = yield call(MyTask.getTaskList, values);
      yield put({
        type: 'save',
        payload: {
          taskList: response.data?.data,
          total: response.data.total,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
